// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Import your auth hook

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const location = useLocation(); // Get current location

  if (!isLoggedIn) {
    // If not logged in, redirect to the login page
    // Pass the current location in state so user can be redirected back after login
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // If logged in, render the child component (the actual page)
  return children;
};

export default ProtectedRoute;